import React from "react";
import RevolutionizeImg from "../../../images/location_new/fold7/uk-androidskyline.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Revolutionize(props) {
  return (
    <div className="revolutionize_section">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Why Choose TekRevol as Your Android App Development Company in UK?
            </h2>
            <p>
              When seeking an Android app development firm with a proven track
              record, TekRevol emerges as the top choice. Our team of skilled
              Android app developers in UK is dedicated to delivering practical
              solutions tailored to your needs. What sets us apart as the best
              Android app development company in London is our commitment to
              transparent communication, timely delivery, and a focus on client
              satisfaction. With TekRevol, you're not just getting an Android
              app – you're gaining a reliable partner for your business's
              success. Your satisfaction is our top priority, and we place great
              value on your input and concerns, allowing us to create an app
              that perfectly aligns with your business goals.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="revolutionize_img"
          >
            <LazyLoadImage
              src={RevolutionizeImg}
              effect="blur"
              alt="TekRevol"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Revolutionize;
